import { LazyVariantItemModel } from './variantItemModel';
import { StaticCache } from 'Shared/cache';

export default class ProductItemModel {
    constructor(data) {
        ko.mapping.fromJS(data, this.#mapping, this);
    }

    cache = new StaticCache("variantItem");

    #mapping = {
        Variants: {
            key: data => ko.utils.unwrapObservable(data.Id),
            create: options => new LazyVariantItemModel(options.data, this.Id())
        }
    }

    url = ko.pureComputed(() => ""/* this.selectedVariant.Url()*/);

    selectedVariant = ko.pureComputed(() => {
        return this.Variants()[0];
    });

    load = async () => {
        if (!this.loaded()) {
            const variant = this.selectedVariant();

            if (variant instanceof LazyVariantItemModel) {
                await this.selectedVariant().load();
            }
        }
    }

    loaded = ko.pureComputed(() => this.selectedVariant().loaded());
}